module.exports = __webpack_public_path__ + "img/empty_list_no_arrow.01cad39a.png";